module.exports = __webpack_public_path__ + "static/PRO001_avatar-28cfcfd1dac795f2ae54bea176b79122.jpg";